import { buildPresignMedia as e, createProgressAggregator as t, matchUploadsToFiles as n, partitionUploadable as r } from "../properties/media/mediaUploadPlan.mjs";
import { DirectUploadError as i, postDirectUpload as a, uploadWithConcurrency as o } from "@maat/api-base";
import { MEDIA_UPLOAD_MAX_BYTES as s } from "@maat/api-main/types";
//#region src/inventoryMedia/runInventoryMediaUpload.ts
var c = 4, l = (e) => {
	let t = e instanceof i ? e.status : void 0;
	return t === void 0 || t >= 500;
}, u = async ({ groups: u, presign: d, carriesEdits: f = !1, onUploadProgress: p }) => {
	let { accepted: m, skipped: h } = r(u, s);
	if (m.length === 0 && !f) return {
		uploaded: 0,
		skipped: h,
		failed: []
	};
	let { matched: g, unattributed: _ } = n((await d(e(m))).uploads, m), v = t(g.reduce((e, t) => e + t.file.size, 0), p), y = [];
	await o(g, c, async (e, t) => {
		let n = () => a({
			url: e.upload.url,
			fields: e.upload.fields,
			file: e.file,
			onProgress: (e) => v.onFileProgress(t, e.loaded)
		});
		try {
			try {
				await n();
			} catch (e) {
				if (!l(e)) throw e;
				await n();
			}
			v.onFileSettled(t, e.file.size);
		} catch (t) {
			y.push({
				category: e.category,
				name: e.file.name,
				status: t instanceof i ? t.status : void 0
			});
		}
	});
	let b = g.length - y.length;
	if (b === 0 && g.length > 0) throw Error("None of the selected photos could be uploaded.");
	return {
		uploaded: b,
		skipped: [...h, ..._],
		failed: y
	};
};
//#endregion
export { u as runInventoryMediaUpload };
